import intlTelInput from 'intl-tel-input';

const handleNewsletterSubmit = () => {
  const form = document.querySelector('[data-footer-signup]');
  const emailInput = form.querySelector('[data-email-input]');
  const phoneInput = form.querySelector('[data-phone-input]');
  const buttonEl = form.querySelector('[data-news-submit]');
  const notifyMessage = document.querySelector('[data-notify-message]');

  let pNum;
  if (phoneInput) {
    // setup international flag dropdwon
    pNum = intlTelInput(phoneInput, {
      nationalMode: true,
      initialCountry: window['blubolt']?.geo?.handle || 'gb',
      preferredCountries: ['gb', 'us'],
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js'
    });

    const errorMap = ['Invalid number', 'Invalid country code', 'Too short', 'Too long', 'Invalid number'];
    const handlePhoneChange = () => {
      if (phoneInput.value.trim()) {
        phoneInput.classList.add('entered')
        if (pNum.isValidNumber()) {
          phoneInput.setCustomValidity('')
        } else {
          const errorCode = pNum.getValidationError();
          phoneInput.setCustomValidity(errorMap[errorCode]);
        }
        phoneInput.reportValidity('')
      } else {
        phoneInput.classList.remove('entered')
      }
    };

    phoneInput.addEventListener('change', handlePhoneChange);
    phoneInput.addEventListener('keyup', handlePhoneChange);
  }
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const isValidEmail = (email) => email.match(regex)
  if (emailInput) {
    const handleEmailChange = () => {
      emailInput.classList.add('entered')
      if (emailInput.value.trim()) {
        if (isValidEmail(emailInput.value)) {
          emailInput.setCustomValidity('')
        } else {
          emailInput.setCustomValidity(notifyMessage.dataset.incorrectEmail);
        }
        emailInput.reportValidity('')
      } else {
        emailInput.classList.remove('entered')
      }
    }
    emailInput.addEventListener('change', handleEmailChange);
    emailInput.addEventListener('keyup', handleEmailChange);
  }

  buttonEl.addEventListener('click', (event) => {
    if (form.checkValidity()) {

      const timestamp = parseInt(Date.now()/1000)

      const identifyObject = {
        'email': emailInput.value
      }
      let phoneConsentRequired = false;
      if (phoneInput.value.trim()) {
        phoneConsentRequired = true;
        identifyObject.phone = pNum.getNumber();
      }

      window['exponea'].identify(
        { 'email_id': emailInput.value },
        identifyObject
      );
      
      window['exponea'].track('newsletter_signup', identifyObject);

      window['exponea'].track('consent', {
        action: 'accept',
        category: 'email',
        // eslint-disable-next-line camelcase
        valid_until: 'unlimited',
        placement: 'Footer signup',
        timestamp: timestamp
      }); 

      if (phoneConsentRequired) {
        window['exponea'].track('consent', {
          action: 'accept',
          category: 'sms',
          // eslint-disable-next-line camelcase
          valid_until: 'unlimited',
          placement: 'Footer signup',
          timestamp: timestamp
        }); 
      }

      form.classList.add('hide');
      notifyMessage.textContent = notifyMessage.dataset.correctMessage;
      notifyMessage.classList.remove('hide')
      
    }
    
    event.preventDefault();
  });
}

export default handleNewsletterSubmit;